export const locale = {
  lang: 'en-CA',
  data: {
    NOTIFICATION_CENTER: {
      TITLE: 'Notifications',
      CLOSE: 'Close',
      FILTER_ARIA: 'Filter notifications',
      FILTER_ACTIVE: 'Active',
      FILTER_NEW: 'Unread',
      FILTER_ARCHIVED: 'Archived',
      MARK_ALL_READ: 'Mark all as read',
      MARK_ALL_READ_DONE: 'All notifications are marked as read.',
      MY_PREFERENCES: 'My notification preferences',
      LIST_ARIA: 'List of notifications',
      OPEN: 'Open',
      MARK_READ: 'Mark as read',
      MARK_UNREAD: 'Mark as unread',
      ARCHIVE: 'Archive',
      UNARCHIVE: 'Unarchive',
      UNREAD: 'Unread',
      READ: 'Read',
      ARCHIVED: 'Archived',
      SHOW_MORE: 'Show more',
      SHOWN_COUNT: '{{count}} of {{total}}',
      LOADING: 'Loading notifications…',
      RETRY: 'Try again',
      ERROR_TITLE: 'Unable to load notifications',
      ERROR_MESSAGE:
        'An error occurred. Check your connection, then try again.',
      ACTION_ERROR: 'The action could not be completed. Try again.',
      NOT_FOUND: 'This notification no longer exists.',
      EMPTY_ACTIVE_TITLE: 'No notifications',
      EMPTY_ACTIVE: 'You are all caught up. New notifications will show here.',
      EMPTY_NEW_TITLE: 'No unread notifications',
      EMPTY_NEW: 'Everything has been read.',
      EMPTY_ARCHIVED_TITLE: 'No archived notifications',
      EMPTY_ARCHIVED: 'The notifications you archive are kept here.',
      SEVERITY: {
        INFO: 'Information',
        SUCCESS: 'Success',
        WARNING: 'Warning',
        ERROR: 'Error',
      },
      PREFS: {
        TITLE: 'My notifications',
        INTRO:
          'Choose, for each notification, where you want to receive it. Your choices only affect your account.',
        LOADING: 'Loading your preferences…',
        ERROR_TITLE: 'Unable to load your preferences',
        ERROR_MESSAGE:
          'An error occurred. Check your connection, then try again.',
        RETRY: 'Try again',
        EMPTY_TITLE: 'No notifications offered',
        EMPTY: 'No notification is offered to your account at the moment.',
        EPHEMERAL_GROUP: 'Flash messages',
        EPHEMERAL_HINT:
          'A flash message shows on screen for a few seconds while you use the application. It is not kept.',
        LOCKED: 'Setting fixed by your organization',
        LOCKED_HINT:
          'Your organization fixed this setting: you cannot change it.',
        CUSTOMIZED: 'Personal choice',
        RESET_ROW: 'Back to the organization setting',
        RESET_PENDING: 'Back to the organization setting on save',
        CHANNEL_ARIA: '{{channel}} — {{label}}',
        SAVE: 'Save',
        CANCEL: 'Cancel',
        CANCEL_CHANGES: 'Discard changes',
        UNSAVED_ONE: '1 change to save',
        UNSAVED_MANY: '{{count}} changes to save',
        SAVED: 'Your notification preferences are saved.',
        ERR_NCP0001:
          'One of these notifications no longer exists. The list was reloaded.',
        ERR_NCP0002:
          'Your organization no longer allows changing one of these notifications. The list was reloaded.',
        ERR_NCP0003:
          'One of the chosen channels is no longer offered for this notification. The list was reloaded.',
      },
      ORG: {
        TITLE: 'Organization notifications',
        INTRO:
          'Decide which notifications your organization sends, to which roles, and where they are sent by default. Each user can then adjust their own choices if you allow it.',
        LOADING: 'Loading settings…',
        ERROR_TITLE: 'Unable to load the settings',
        ERROR_MESSAGE:
          'An error occurred. Check your connection, then try again.',
        FORBIDDEN:
          'Only owners and administrators can change the organization notifications.',
        RETRY: 'Try again',
        EMPTY_TITLE: 'No notification to configure',
        EMPTY: 'No notification is offered to your organization.',
        EPHEMERAL_GROUP: 'Flash messages',
        ENABLED: 'Enabled',
        DISABLED: 'Disabled',
        ENABLE_ARIA: 'Enable or disable the notification "{{label}}"',
        DISABLED_HINT: 'This notification is disabled: nobody receives it.',
        TARGET_ROLES: 'Targeted roles',
        ALL_ROLES: 'All roles',
        LAST_ROLE_HINT:
          'At least one role must stay checked. To send it to nobody, disable the notification.',
        USERS_AUDIENCE_HINT:
          'This notification is sent to the people concerned: the choice of roles does not apply.',
        DEFAULT_CHANNELS: 'Channels enabled by default',
        ALLOW_USER_OVERRIDE: 'Allow each user to choose',
        ALLOW_USER_OVERRIDE_HINT:
          'If this option is unchecked, the default channels apply to everyone, without exception.',
        CUSTOMIZED: 'Customized',
        RESET: 'Back to default values',
        SAVED: 'Setting saved.',
        RESET_DONE: 'The notification is back to its default values.',
        ERR_NCS0002:
          'One of the chosen channels is not offered for this notification.',
        ERR_NOT_FOUND: 'This notification no longer exists.',
      },
    },
  },
};
